"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkin_time_1 = require("./checkin_time");
var transport_config_1 = require("./transport_config");
var State = /** @class */ (function () {
    function State() {
        this.departure = true;
        this.departureConfig = new transport_config_1.TransportConfig();
        this.arrival = true;
        this.arrivalConfig = new transport_config_1.TransportConfig();
        this.checkinTime = new checkin_time_1.CheckinTime();
        this.selectedTariffType = 'SPAR';
        this.selectedClass = '2';
        this.transportations = [];
        this.totalPrice = 0;
    }
    return State;
}());
exports.State = State;
//# sourceMappingURL=state.js.map